import { Layout, LegacyCard, SkeletonDisplayText, Text } from "@shopify/polaris";
import React, { useContext } from "react";
import { ContextUser } from "src/context/ContextUser";
import { useSupplierQuery } from "src/graphql/codegen_graphql";

export function FulFilmentRate() {
  const { merchant } = useContext(ContextUser);
  const { data, loading } = useSupplierQuery({
    variables: {
      supplierId: Number(merchant.id ?? 0),
    },
  });

  return (
    <React.Fragment>
      {loading && <div>Loading...</div>}
      <Layout.Section variant="fullWidth">
        <LegacyCard>
          <LegacyCard.Section>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div style={{ textAlign: "start" }}>
                <h2 style={{ fontSize: "0.8125rem", fontWeight: 650, letterSpacing: 0, lineHeight: "1.25rem" }}>
                  Fulfillment Rate
                </h2>
                {data ? (
                  <Text as="h4" variant="headingLg" tone="magic-subdued">
                    {Number(data.supplier?.fulfilmentRate ?? 0).toFixed(2)}%
                  </Text>
                ) : (
                  <SkeletonDisplayText size="large" />
                )}
              </div>
              <div style={{ textAlign: "center" }}>
                <h2 style={{ fontSize: "0.8125rem", fontWeight: 650, letterSpacing: 0, lineHeight: "1.25rem" }}>
                  Product Rating
                </h2>
                {data ? (
                  <Text as="h4" variant="headingLg" tone="magic-subdued">
                    {Number(data.supplier?.productAverageRating ?? 0).toFixed(2)}
                  </Text>
                ) : (
                  <SkeletonDisplayText size="large" />
                )}
              </div>
              <div style={{ textAlign: "right" }}>
                <h2 style={{ fontSize: "0.8125rem", fontWeight: 650, letterSpacing: 0, lineHeight: "1.25rem" }}>
                  Followers
                </h2>
                {data ? (
                  <Text as="h4" variant="headingLg" tone="magic-subdued">
                    {data.supplier?.follower ?? 0}
                  </Text>
                ) : (
                  <SkeletonDisplayText size="large" />
                )}
              </div>
            </div>
          </LegacyCard.Section>
        </LegacyCard>
      </Layout.Section>
    </React.Fragment>
  );
}
